import OlaggFormSelect from "./OlaggFormSelect";
import OlaGGFormInput from "./OlaggFormInput";
import { useState } from "react";
import { Quest, QUEST_TYPES } from "@olagg/db-types";
import { Flex } from "@chakra-ui/react";

const xAccountsOptions = [
    { value: '1478020222233763844', label: 'Ola Guild Games' },
    { value: '2033526579003822081', label: 'NoxCorpAI' },
    { value: '2044057467550564352', label: "Don't Spend" },
    { value: '2008946828428087296', label: 'Don Roi' },
    { value: '2041864387724500992', label: 'Don Roi BR' },
]

const twitterQuestsSubtypesOptions = [
    { value: 'follow', label: 'Follow' },
    { value: 'like', label: 'Like' },
    { value: 'retweet', label: 'Retweet' },
    { value: 'tweet', label: 'Tweet' },
]

const twitterV2QuestsSubtypesOptions = [
    { value: 'follow', label: 'Follow' },
    { value: 'retweet', label: 'Retweet' },
    { value: 'reply', label: 'Reply' },
    { value: 'tweet', label: 'Tweet' },
]

const TwitterQuestForm = ({ quest, showLocaleInputs, onSubtypeChange, type }: { quest: Quest, showLocaleInputs: boolean, onSubtypeChange?: (subtype: string) => void, type: QUEST_TYPES }) => {
    const [subtype, setSubtype] = useState(quest?.extraData?.subtype || null);

    const handleSubtypeChange = (value: string) => {
        setSubtype(value);
        onSubtypeChange?.(value);
    };

    return (
        <>
            <OlaggFormSelect
                newVersion={true}
                controlName="extraData.subtype"
                label="Subtipo"
                staticOptions={type === QUEST_TYPES.TWITTER_V2 ? twitterV2QuestsSubtypesOptions : twitterQuestsSubtypesOptions}
                isSearchable={false}
                onChange={handleSubtypeChange}
            />
            {subtype === 'tweet' && (
                <>
                    <OlaGGFormInput
                        controlName="extraData.tweetText"
                        label="Tweet text"
                        required
                    />
                    {showLocaleInputs && (
                        <Flex direction='column' w='full' bgColor='#20173d' p='8' borderRadius={'12px'}>
                            <OlaGGFormInput
                                controlName="extraData.en.tweetText"
                                label="Tweet text (EN)"
                                required
                            />
                            <OlaGGFormInput
                                controlName="extraData.pt.tweetText"
                                label="Tweet text (PT)"
                                required
                            />
                        </Flex>
                    )}
                    <OlaGGFormInput
                        controlName="extraData.modalButtonText"
                        label="Texto CTA"
                        required
                    />
                    {showLocaleInputs && (
                        <Flex direction='column' w='full' bgColor='#20173d' p='8' borderRadius={'12px'}>
                            <OlaGGFormInput
                                controlName="extraData.en.modalButtonText"
                                label="Texto CTA (EN)"
                                required
                            />
                            <OlaGGFormInput
                                controlName="extraData.pt.modalButtonText"
                                label="Texto CTA"
                                required
                            />
                        </Flex>
                    )}
                </>

            )}
            {subtype !== 'tweet' && subtype !== 'follow' && (
                <>
                    <OlaGGFormInput
                        controlName="extraData.tweetId"
                        label="Tweet ID"
                        required
                    />
                    {showLocaleInputs && (
                        <Flex direction='column' w='full' bgColor='#20173d' p='8' borderRadius={'12px'}>
                            <OlaGGFormInput
                                controlName="extraData.en.tweetId"
                                label="Tweet ID (EN)"
                                required
                            />
                            <OlaGGFormInput
                                controlName="extraData.pt.tweetId"
                                label="Tweet ID (PT)"
                                required
                            />
                        </Flex>
                    )
                    }
                </>
            )}
            {subtype === 'follow' && (
                type === QUEST_TYPES.TWITTER_V2 ? (
                    <OlaggFormSelect
                        newVersion={true}
                        controlName="extraData.username"
                        label="User ID de X"
                        staticOptions={xAccountsOptions}
                        isSearchable={false}
                    />
                ) : (
                    <OlaGGFormInput
                        controlName="extraData.username"
                        label="Username en X"
                        required
                    />
                )
            )}
        </>
    )
};

export default TwitterQuestForm;